import React, { Component, PropTypes } from 'react'
import {Link} from 'react-router'
import $ from 'jquery'
import { ROUTE_HIRING, ROUTE_INTRODUCTION, ROUTE_MEDIA_VIDEOS } from '../../../constants'

/*eslint-disable no-script-url*/
class Slider extends Component {

  componentDidMount() {
    $(document).ready(function(){
      $('.slider').slider({full_width: true});
    });
  }

  launchPlayer() {
    const { setShowPlayer } = this.props
    setShowPlayer(true)
    $('.modal').modal({ opacity: 0, dismissible: false })
    $('#modalPlaylist').modal('open')
  }

  render() {
    return (
      <div className="slider">
        <ul className="slides">
          <li>
            <img src="/images/background/home.jpg" alt="Accueil" />
              <div className="caption center-align">
                <h3>Mouv' your Baudet</h3>
                <h5 className="light grey-text text-lighten-3">Fanfare festive pictave garantie 100% équidé</h5>
              </div>
          </li>
          <li>
            <img src="/images/background/hiring.jpg" alt="Recrutement" />
            <div className="caption left-align">
              <h3>La fanfare recrute !</h3>
              <h5 className="light grey-text text-lighten-3">Tu joues de la TROMPETTE, du TROMBONE, du TUBA BASSE, ou encore de la BATTERIE ? C'est par ici !</h5>
              <Link activeClassName={'active'} to={ROUTE_HIRING} className="waves-effect waves-light btn red-button"><i className="material-icons left">star</i>Recrutement</Link>

            </div>
          </li>
          <li>
            <img src="/images/background/media.jpg" alt="Présentation" />
              <div className="caption right-align">
                <h3>Besoin d'une animation ?</h3>
                <h5 className="light grey-text text-lighten-3">Mariages, divorces, fêtes de village... les Mouv' your Baudet animent POUR VOUS toutes sortes d'évènements !</h5>
                <Link activeClassName={'active'} to={ROUTE_INTRODUCTION} className="waves-effect waves-light btn light-blue-button"><i className="material-icons left">supervisor_account</i>Présentation</Link>
              </div>
          </li>
          <li>
            <img src="/images/background/performances.jpg" alt="Prestations" />
              <div className="caption left-align">
                <h3>Un répertoire festif et varié !</h3>
                <h5 className="light grey-text text-lighten-3">Disco, pop, dance, techno, ska, rock, metal, bal musette...</h5>
                <a href="javascript:void(0)" onClick={() => this.launchPlayer()} className="waves-effect waves-light btn orange-button"><i className="material-icons left">audiotrack</i>Enregistrements</a>
                <Link activeClassName={'active'} to={ROUTE_MEDIA_VIDEOS} className="waves-effect waves-light btn red-button"><i className="material-icons left">video_library</i>Vidéos</Link>
              </div>
          </li>
        </ul>
      </div>
    )
  }

}

Slider.propTypes = {
  setShowPlayer: PropTypes.func
}

export default Slider


/** WEBPACK FOOTER **
 ** ./src/components/Home/Slider/Slider.jsx
 **/